import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { getDurataChiamate } from "../../../const/CardDati";
import { useEffect, useState } from "react";
import axios from "axios";
import Style from "./chart.module.css";
import { Line } from "react-chartjs-2";
import { DataToObjChartDurata } from "../../../functions/DataToObjChart";
import { chartOptions } from "../../../const/chartOptions";
import Divider from "@mui/material/Divider";
import { Grid, Skeleton } from "@mui/material";
import { CDCard, CDCardContent, CDCardHeader} from "../../../const/CDCardStyles";
import IconTooltip from "../Tooltip/Tooltip";
import {chartDurataChiamateTexts} from "../../../const/CardTexts";
import { useDispatch } from 'react-redux';
import {notificationOpen}  from "../../../redux/reducers/notification-reducer";
import handlerError from "../../../functions/handlerError";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const isCorrectRangeData = true;
const urlBase = process.env.REACT_APP_URL;
const DateComponent = getDurataChiamate;


const ChartDurataChiamate = ({ dataPicker, refresh, deviceFilter }) => {
  const dispatch = useDispatch();
  const [isFetching, setIsFetching] = useState();
  const [chartData, setChartData] = useState();

  useEffect(() => {
    (async () => {
      if (isCorrectRangeData) {
        setIsFetching(true);
        const { startDate, endDate } = dataPicker;
        const { action, method } = DateComponent;
        const body = { startDate, endDate, deviceId: deviceFilter };
        let url = urlBase + action;
        try {
          const response = await axios({
            method: method,
            url,
            data: body,
          });
          const chartData = DataToObjChartDurata(response.data);
          setChartData(chartData);
        } catch(error){
          console.error(error);
          const notificationError = handlerError(error)
          dispatch(notificationOpen(notificationError))
        } 
        setIsFetching(false);
      }
    })();
  }, [refresh, dataPicker, deviceFilter]);

  return (
    <>
    <Grid item xs={12} sm={12} lg={6}>
      <CDCard>
        {!isFetching ? (
          chartData && (
            <>
                <CDCardHeader title={
                  <IconTooltip data={chartDurataChiamateTexts} />
                } />
                <Divider/>
                <CDCardContent className={Style.cardContent}>
                  <Line
                    options={chartOptions}
                    data={chartData}
                    className={Style.container}
                  />
                </CDCardContent>
            </>
          )
        ) : (
          <>    
            <CDCardHeader title={
              <IconTooltip data={chartDurataChiamateTexts} />
            } />
            <Divider/>
            <CDCardContent className={Style.cardContent}>
              <Skeleton variant="rectangular" height={960} />
            </CDCardContent>
          </>
        )}
      </CDCard>
    </Grid>
  </>
  );
};


export default ChartDurataChiamate;
